import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Modal } from './Modals/Modal';
import { useTheme } from '../contexts/ThemeContext';
import SettingsMenu from './Modals/SettingsMenu';

import '../sassStyles/themes/LightTheme.scss';
import '../sassStyles/themes/DarkTheme.scss';
import '../sassStyles/themes/GardenTheme.scss';
import '../sassStyles/themes/Common.scss';




export function FernSandbox() {
    const { theme, onThemeChange, themeOptions } = useTheme();
    const [show, setShow] = useState(false);

    const handleClick = () => {
        setShow(true);
    }

    return (
        <div className={`${theme}-fsb`} data-testid="fern-sandbox-container">
            <header className="fsb-header">

                <button
                    id='settings-button'
                    className='button'
                    type="button"
                    onClick={handleClick}
                    title='Settings'
                >
                    <FontAwesomeIcon icon="fa-solid fa-gear" />
                </button>

                <Modal
                    show={show}
                    setShow={setShow}
                    title='Settings'
                    content={
                        <SettingsMenu onThemeChange={onThemeChange} options={themeOptions} />
                    }
                />
                <div id='heading-container'>
                    <p id="heading">Fern's Sandbox</p>
                </div>
            </header>
            <nav>
                <ul>
                    <li>Home</li>
                    <li>About</li>
                    <li>Services</li>
                </ul>
            </nav>
        </div>
    );
}

